import { render, staticRenderFns } from "./RouterViewSlider.vue?vue&type=template&id=38bf6db2&scoped=true&"
import script from "./RouterViewSlider.vue?vue&type=script&lang=ts&"
export * from "./RouterViewSlider.vue?vue&type=script&lang=ts&"
import style0 from "./RouterViewSlider.vue?vue&type=style&index=0&id=38bf6db2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf6db2",
  null
  
)

export default component.exports